define(function(require) {
    'use strict';

    var AuthManager = require('managers/auth.manager');
    var config = require('config');
    var identtSubscriptionTags = [
        'portal/identt/verification_completed',
        'portal/identt/verification_failed'
    ];

    return AuthManager.extend({
        _getSubscriptionTags: function() {
            return (config.get('sessionSubscriptionTags') || '')
                .split(',')
                .map(function(balanceType) {
                    return balanceType.trim();
                })
                .concat(['uam/hidden/playerRecentGames'], identtSubscriptionTags);
        }
    });
});
